import R from 'ramda'

const ONLY_DISPLAY_TYPE = 'Only'
const ONLY_TRIGGER_TYPE = 'ONLY'

const isOnlyFormTrigger = R.propEq('type', ONLY_DISPLAY_TYPE)

const convertOnlyFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(ONLY_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T
})

export { isOnlyFormTrigger, convertOnlyFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/only.js